import axios from "utils/axios"
import * as APITypes from "constants/API"
import { BANCA_JOURNEY, COOKIE_PARA_NAME_FOR_JOURNEY_ID, NUMBER_REGEX, SAMS_JOURNEY } from "constants/Constants"
import getCookieValue from "utils/getCookieValue/getCookieValue"
import OptimizationStore from "modules/optimization/store/OptimizationStore"
import { toJS } from "mobx"
import getCookie from "utils/journeyIdCookie/getJourneyId"
import isReverseApiCall from "utils/isReverseApiCall"

class Utils {
  togglePhoneNumberCheckbox = (
    formController,
    memberType,
    fieldName,
    value
  ) => {
    formController.$(memberType).$(fieldName).set("value", !value)

    let mobileNoValue = formController.$(memberType).$("mobile_number").value
    let mobileCodeValue = formController.$(memberType).$("mobile_number_code").value

    if (value === false && mobileNoValue) {
      formController.$(memberType).$("whatsapp_mobile_number").value = mobileNoValue
      formController.$(memberType).$("whatsapp_mobile_number_code").value = mobileCodeValue
    } else {
      formController.$(memberType).$("whatsapp_mobile_number").value = ''
      formController.$(memberType).$("whatsapp_mobile_number_code").value = ''
    }
  }

  updateValues = (formController, member, fieldName, value) => {
    let updatedValue = value
    // let NameRegEx = new RegExp("^([A-Za-z]{1,30})$")
    // Name Regex with space
    let NameRegEx = /^(?![\s-])[\A-Za-z.\s-]{1,30}$/

    if (
      fieldName == "first_name" ||
      fieldName == "middle_name" ||
      fieldName == "last_name"
    ) {
      if (NameRegEx.test(updatedValue)) {
        updatedValue = updatedValue
      } else {
        updatedValue = formController.$(member).$(fieldName).value
        if (updatedValue.length == 1) {
          updatedValue = ""
        }
      }

      if (updatedValue.length == 1) {
        updatedValue = updatedValue.toUpperCase()
      }
    }

    formController.$(member).$(fieldName).value = updatedValue
  }

  onPreviewBtnCick = async (formValues) => {
    const dataArray = []

    let familyValues = []

    let source_system = getCookieValue("source")
    let channel_code = document.cookie.split("; ").find((row) => row.startsWith("channel_code="))?.split("=")[1];


    for (let key in formValues) {
      familyValues.push(formValues[key])
    }

    familyValues.forEach((member) => {
      const {
        id: proposer_id,
        salutation,
        first_name,
        middle_name,
        last_name,
        email,
        mobile_number_code: mobile_country_code,
        mobile_number: mobile_no,
        same_as_mobile_number: mobile_whatsapp_same,
        whatsapp_mobile_number_code: whatsapp_country_code,
        whatsapp_mobile_number: whatsapp_no,
      } = member

      let memberObj = {
        proposer_id,
        salutation: salutation.id,
        first_name,
        middle_name,
        last_name,
        email,
        mobile_country_code,
        mobile_no,
        mobile_whatsapp_same,
        whatsapp_country_code,
        whatsapp_no,
      }

      dataArray.push(memberObj)
    })

    const dataToBeSubmitted = {
      proposer_list: dataArray,
    }



    let response = await axios.post(
      APITypes.SAVE_COMMUNICATION_DETAILS,
      dataToBeSubmitted
    )

    if (response.status == "success") {
      let reqObj = {
        journeyId: getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID),
        familyProductIdList: toJS(OptimizationStore.familyProductIdList)
      }
      if (source_system === SAMS_JOURNEY || source_system === BANCA_JOURNEY) {
        // let dataResponse = axios.post(APITypes.SMAS_LEAD_STATUS, { journeyId: getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID) })
        let data = axios.post(APITypes.SMAS_LEAD_UPDATE, reqObj)
      }
      if (isReverseApiCall()) {
        let response = axios.post(APITypes.CREATE_UPDATE_LEAD_SAMS, reqObj)
      }
      // if (source_system === SAMS_JOURNEY) {
      //   let data = axios.post(APITypes.CREATE_LEAD_SAMS, dataToBeSubmitted)
      // }
    }

    return response.status
  }

  mobileNumberOnChange = (formController, memberType, fieldType, value) => {
    if (NUMBER_REGEX.test(value)) {
      formController.$(memberType).$(fieldType).value = value
      return
    }
    if (value.length <= 1) {
      formController.$(memberType).$(fieldType).value = ""
    }
  }


}

export default new Utils()
